import React, {useState, useEffect} from "react";
import {Container, Slide, Dialog, TextField, CircularProgress} from "@material-ui/core";
import {MuiThemeProvider} from "@material-ui/core/styles";
import CustomToolbar from "../../CustomToolbar";
import MUIDataTable from "mui-datatables";
import {datatableThemeInTabsPage} from "assets/css/datatable-theme.js";
import Moment from "react-moment";
import "react-dropzone-uploader/dist/styles.css";
import Autocomplete from "@material-ui/lab/Autocomplete";

import {useHistory} from "react-router-dom";
import "./LiveOperation.css";
import axios from "axios";
import FilterComponent from "./Components/FilterComponent.js";
import TabsOnTop from "./Components/TabsOnTop.js";
import SnDialog from "./Components/SnDialog.js";
import OperationDialog from "./Components/OperationDialog.js";
import JobDialog from "./Components/JobDialog.js";
import CustomToolbarSelect from "./Components/CustomToolbar/CustomToolbarSelect.js";
import {getCookie} from "../../components/auth/Helpers";
import UploadExcel from "./Components/UploadExcel";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullWidthTabs() {
  const token = getCookie("token");
  let history = useHistory();
  const [tabIndex, setTabIndex] = useState(0); //tabs tabIndex
  const [isLoading, setIsLoading] = useState(false);
  const [warehousesList, setWarehousesList] = useState({});
  const [storesList, setStoresList] = useState({});
  const [items, setItems] = useState([]); //table items
  const [itemsFiltered, setItemsFiltered] = useState(); //table items
  const [filterDialog, setFilterDialog] = useState(false);
  const [openSnDialog, setOpenSnDialog] = useState(false);
  const [snId, setSnId] = useState();
  const [citiesList, setCitiesList] = useState([]);
  const [neighbourhoodsList, setNeighbourhoodsList] = useState([]);
  const [clientsList, setClientsList] = useState([]);
  const [suppliersList, setSuppliersList] = useState([]);
  const [cabinetsList, setCabinetsList] = useState([]);
  const [openOperationDialog, setOpenOperationDialog] = useState(false);
  const [openJobDialog, setOpenJobDialog] = useState(false);
  const [operationId, setOperationId] = useState();
  const [jobNumber, setJobNumber] = useState();
  const [supplierName, setSupplierName] = useState("");
  const [liveOperationsToExport, setLiveOperationsToExport] = useState([]);
  const [itemsBackup, setItemsBackup] = useState([]); //Search
  const [statusUpdated, setStatusUpdated] = useState([]); //Status Updated
  const [pagingInfo, setPagingInfo] = useState({page: 0, limit: 20, skip: 0, count: 20}); //Pagination Info
  const [searchEntry, setSearchEntry] = useState([]); //searchEntry
  const [countLiveOperations, setCountLiveOperations] = useState({}); //countStatus
  const [countAll, setCountAll] = useState([]); //countAll
  const [updateData, setUpdateData] = useState(1);
  const [importModalVisible, setImportModalVisible] = useState(false);
  const [filterFormValues, setFilterFormValues] = useState({
    client: "",
    fridgesType: "",
    operationType: "",
    status: "",
    fromDate: "",
    toDate: "",
    preventive: false,
    store: "",
    warehouse: "",
    condition: "",
  });
  useEffect(() => {
    const fetchData = async () => {
      await axios
        .all([
          axios.get(`${process.env.REACT_APP_BASE_URL}/cabinets`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/clients`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/cities`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/neighbourhoods`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/suppliers`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          // axios.get(`${process.env.REACT_APP_BASE_URL}/liveOperations/export`, {
          //   headers: {Authorization: `Bearer ${token}`},
          // }),
          // axios.get(`${process.env.REACT_APP_BASE_URL}/liveOperations/count`, {
          //   headers: {Authorization: `Bearer ${token}`},
          // }),

          axios.get(`${process.env.REACT_APP_BASE_URL}/warehouses`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/stores`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
        ])
        .then((response) => {
          setCabinetsList(response[0].data.data);
          setClientsList(response[1].data);
          setCitiesList(response[2].data);
          setNeighbourhoodsList(response[3].data);
          setSuppliersList(response[4].data);
          // setLiveOperationsToExport(response[5].data);
          // setCountLiveOperations(response[6].data);

          setWarehousesList(response[5].data);
          setStoresList(response[6].data);
        });
    };
    fetchData();
  }, [statusUpdated]);

  const handleExport = async () => {
    try {
      setItemsFiltered();
      let filterArray = [];
      if (filterFormValues.client._id) filterArray.push(`clientId=${filterFormValues.client._id}`);
      if (filterFormValues.fridgesType._id)
        filterArray.push(`fridgeTypeId=${filterFormValues.fridgesType._id}`);
      if (filterFormValues.operationType.name)
        filterArray.push(`operationType=${filterFormValues.operationType.name}`);
      if (filterFormValues.status) filterArray.push(`status=${filterFormValues.status}`);
      if (filterFormValues.fromDate) filterArray.push(`fromDate=${filterFormValues.fromDate}`);
      if (filterFormValues.toDate) filterArray.push(`toDate=${filterFormValues.toDate}`);
      if (filterFormValues.preventive) filterArray.push(`exceededPreventive=true`);
      if (filterFormValues.condition) filterArray.push(`condition=${filterFormValues.condition.id}`);

      if (filterFormValues.location) filterArray.push(`location=${filterFormValues.location.id}`);
      if (filterFormValues.store) filterArray.push(`location_id=${filterFormValues.store._id}`);
      if (filterFormValues.warehouse) filterArray.push(`location_id=${filterFormValues.warehouse._id}`);

      if (filterFormValues.ship_from) filterArray.push(`ship_from=${filterFormValues.ship_from.id}`);
      if (filterFormValues.ship_from_store)
        filterArray.push(`ship_from_id=${filterFormValues.ship_from_store._id}`);
      if (filterFormValues.ship_from_warehouse)
        filterArray.push(`ship_from_id=${filterFormValues.ship_from_warehouse._id}`);

      if (filterFormValues.ship_to) filterArray.push(`ship_to=${filterFormValues.ship_to.id}`);
      if (filterFormValues.ship_to_store)
        filterArray.push(`ship_to_id=${filterFormValues.ship_to_store._id}`);
      if (filterFormValues.ship_to_warehouse)
        filterArray.push(`ship_to_id=${filterFormValues.ship_to_warehouse._id}`);

      filterArray.push(`status=${tabIndex > 0 ? tabsTitle[tabIndex - 1] : ""}`);

      const response = await axios.get(
        `${
          process.env.REACT_APP_BASE_URL
        }/liveOperations/export?searchEntry=${searchEntry}&${filterArray.join("&")}`,
        {
          responseType: "blob",
          headers: {Authorization: `Bearer ${token}`},
        }
      );

      // ✅ Create blob and download using anchor
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Operations.xlsx"); // filename
      document.body.appendChild(link);
      link.click();

      // ✅ Cleanup
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Export failed", err);
    }
  };

  const getCounts = () => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/liveOperations/count?searchEntry=${searchEntry}`, {
        headers: {Authorization: `Bearer ${token}`},
      })
      .then((response) => {
        setCountLiveOperations(response.data);
      })
      .catch((err) => {});
  };

  const fetchData = async () => {
    setItemsFiltered(null);
    setIsLoading(true);

    let filterArray = [];
    if (filterFormValues.client._id) filterArray.push(`clientId=${filterFormValues.client._id}`);
    if (filterFormValues.fridgesType._id)
      filterArray.push(`fridgeTypeId=${filterFormValues.fridgesType._id}`);
    if (filterFormValues.operationType && filterFormValues.operationType.name)
      filterArray.push(`operationType=${filterFormValues.operationType.name}`);
    if (filterFormValues.status) filterArray.push(`status=${filterFormValues.status}`);
    if (filterFormValues.fromDate) filterArray.push(`fromDate=${filterFormValues.fromDate}`);
    if (filterFormValues.toDate) filterArray.push(`toDate=${filterFormValues.toDate}`);
    if (filterFormValues.preventive) filterArray.push(`exceededPreventive=true`);
    if (filterFormValues.condition) filterArray.push(`condition=${filterFormValues.condition.id}`);

    if (filterFormValues.location) filterArray.push(`location=${filterFormValues.location.id}`);
    if (filterFormValues.store) filterArray.push(`location_id=${filterFormValues.store._id}`);
    if (filterFormValues.warehouse) filterArray.push(`location_id=${filterFormValues.warehouse._id}`);

    if (filterFormValues.ship_from) filterArray.push(`ship_from=${filterFormValues.ship_from.id}`);
    if (filterFormValues.ship_from_store)
      filterArray.push(`ship_from_id=${filterFormValues.ship_from_store._id}`);
    if (filterFormValues.ship_from_warehouse)
      filterArray.push(`ship_from_id=${filterFormValues.ship_from_warehouse._id}`);

    if (filterFormValues.ship_to) filterArray.push(`ship_to=${filterFormValues.ship_to.id}`);
    if (filterFormValues.ship_to_store) filterArray.push(`ship_to_id=${filterFormValues.ship_to_store._id}`);
    if (filterFormValues.ship_to_warehouse)
      filterArray.push(`ship_to_id=${filterFormValues.ship_to_warehouse._id}`);

    await axios(
      `${process.env.REACT_APP_BASE_URL}/liveOperations?limit=${pagingInfo.limit}&skip=${
        pagingInfo.skip
      }&searchEntry=${searchEntry}&status=${tabIndex > 0 ? tabsTitle[tabIndex - 1] : ""}&${filterArray.join(
        "&"
      )}`,
      {
        responseType: "json",
        headers: {Authorization: `Bearer ${token}`},
      }
    )
      .then((response) => {
        // getCounts();
        setCountLiveOperations({total: response.data.count, data: response.data.tabs});
        setPagingInfo({...pagingInfo, count: response.data.count});
        setItems(response.data.data);
        setItemsBackup(response.data.data);
        return setIsLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  useEffect(() => {
    fetchData();
  }, [statusUpdated, pagingInfo.page, pagingInfo.limit, searchEntry, updateData, tabIndex]);

  /************************* -Tabledata START- ***************************/
  const columns = [
    {
      name: "_id",
      options: {display: false},
    },
    {
      name: "sn",
      options: {display: false},
    },
    {
      name: "job_number",
      label: "Job #",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          let supplierName = "";
          if (tableMeta.rowData[10]) {
            let supplierValue = suppliersList.filter((e) => e._id == tableMeta.rowData[10]);
            if (supplierValue.length) supplierName = supplierValue[0]?.name;
          }
          return (
            <div>
              <a onClick={() => handleOpenJobDialog(value, supplierName)}>{value}</a>
            </div>
          );
        },
      },
    },
    {
      name: "createdAt",
      label: "Creation Date",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <Moment format="DD MMM YYYY - HH:mm">{value}</Moment>;
        },
      },
    },
    {
      name: "promise_date",
      label: "Promise Date",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <Moment format="DD MMM YYYY - HH:mm">{value}</Moment>;
        },
      },
    },
    {
      name: "operation_number",
      label: "Operation #",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          let supplierName = "";
          if (tableMeta.rowData[10]) {
            let supplierValue = suppliersList.filter((e) => e._id == tableMeta.rowData[10]);
            if (supplierValue.length) supplierName = supplierValue[0]?.name;
          }
          return (
            <div>
              <a onClick={() => handleOpenOperationDialog(tableMeta.rowData[0], supplierName)}>{value}</a>
            </div>
          );
        },
      },
    },
    {name: "operation_type", label: "Operation Type"},
    {
      name: "sn",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value) {
            let snValue = cabinetsList.filter((e) => e._id == value);
            return (
              <div>
                <a onClick={() => handleOpenSnDialog(value)}>{snValue.length ? snValue[0].sn : "-"}</a>
              </div>
            );
          }
        },
      },
    },

    {
      name: "cabinetDetails",
      label: "Type Code",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? value?.type?.code : "";
        },
      },
    },

    {
      name: "cabinetDetails",
      label: "Type name",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? value?.type?.name : "";
        },
      },
    },

    {
      name: "cabinetDetails",
      label: "Condition",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              {value ? value?.status : ""}
              <br />
              {value ? value?.condition : ""}
            </div>
          );
        },
      },
    },

    {
      name: "brand",
      options: {
        customBodyRender: (value, tableMeta, updateValue) =>
          value ? (
            <div className="d-flex">
              <div className="avatar_circle">{value.substring(0, 2)}</div>
              {value}
            </div>
          ) : null,
      },
    },
    {
      name: "client_id",
      label: "Client Name",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value) {
            let clientValue = clientsList.filter((e) => e._id == value);
            return clientValue.length ? clientValue[0]?.name : "-";
          }
        },
      },
    },
    {
      name: "initiation_address",
      label: "Initiation Address",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value) {
            let cityValue = "-";
            let neighbourhoodValue = "-";
            if (citiesList.filter((e) => e._id == value.city_id)[0]) {
              cityValue = citiesList.filter((e) => e._id == value.city_id)[0].name;
            }
            if (neighbourhoodsList.filter((e) => e._id == value.neighbourhood_id)[0]) {
              neighbourhoodValue = neighbourhoodsList.filter((e) => e._id == value.neighbourhood_id)[0]?.name;
            }
            return (
              <div style={{width: 230, display: "flex", alignItems: "center"}}>
                {cityValue != "-" ? <div className="avatar_circle">{cityValue.substring(0, 2)}</div> : null}
                <div>
                  {value?.code}
                  <br />
                  {cityValue}
                  <br />
                  {neighbourhoodValue}
                  <br />
                  <strong>
                    {value ? value.shop_name : "-"} / {value ? value.mobile : "-"}
                  </strong>
                </div>
              </div>
            );
          }
        },
      },
    },
    {
      name: "execution_address",
      label: "Execution Address",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value) {
            let cityValue = "-";
            let neighbourhoodValue = "-";
            if (citiesList.filter((e) => e._id == value.city_id)[0]) {
              cityValue = citiesList.filter((e) => e._id == value.city_id)[0].name;
            }
            if (neighbourhoodsList.filter((e) => e._id == value.neighbourhood_id)[0]) {
              neighbourhoodValue = neighbourhoodsList.filter((e) => e._id == value.neighbourhood_id)[0]?.name;
            }
            return (
              <div style={{width: 230, display: "flex", alignItems: "center"}}>
                {cityValue != "-" ? <div className="avatar_circle">{cityValue.substring(0, 2)}</div> : null}
                <div>
                  {value?.code}
                  <br />
                  {cityValue}
                  <br />
                  {neighbourhoodValue}
                  <br />
                  <strong>
                    {value ? value.shop_name : "-"} / {value ? value.mobile : "-"}
                  </strong>
                </div>
              </div>
            );
          }
        },
      },
    },
    {
      name: "supplier_id",
      label: "supplier",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value) {
            let supplierValue = suppliersList.filter((e) => e._id == value);
            return supplierValue.length ? supplierValue[0]?.name : "-";
          }
        },
      },
    },
    {name: "client_approval", label: "Client Approval"},
    {name: "logistic_status", label: "Logistic Status"},
    {name: "status"},
    {name: "last_status_user", label: "Last Status User"},
    {
      name: "last_status_update",
      label: "Last Status Update",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value) {
            return <Moment format="DD MMM YYYY - HH:mm">{value}</Moment>;
          }
        },
      },
    },

    {
      name: "PhysicalDeliveryAttemptCount",
      label: "Delivery Attempts",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? value : 0;
        },
      },
    },
    {
      name: "PhysicalPickupAttemptCount",
      label: "Pickup Attempts",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? value : 0;
        },
      },
    },
    {
      name: "replacement",
      label: "Replacement",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? "YES" : "NO";
        },
      },
    },
  ];

  const tabsTitle = [
    "In Progress",
    "Completed",
    "Failed",
    "On Hold",
    "Assigned",
    "Unassigned",
    "Accepted",
    "Canceled",
    "Return To Origin",
  ];
  useEffect(() => {
    let num =
      countLiveOperations && countLiveOperations.data
        ? countLiveOperations.data[tabsTitle[tabIndex - 1]] || 0
        : 0;
    console.log(tabsTitle[tabIndex - 1], num);
  }, [tabIndex]);

  const handleImport = () => {
    setImportModalVisible(true);
  };
  const closeImport = (refresh) => {
    setImportModalVisible(false);
    fetchData();
  };

  const options = {
    filter: false,
    onRowsDelete: null,
    rowsPerPage: pagingInfo.limit,
    rowsPerPageOptions: [20, 50, 100],
    selectToolbarPlacement: "replace",
    download: false,
    customToolbar: () => {
      return (
        <CustomToolbar
          listener={handleOpenAddDialog}
          handleFilter={handleFilter}
          handleExport={handleExport}
          handleImport={handleImport}
        />
      );
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
      const snSelected = displayData[selectedRows.data[0].dataIndex]
        ? displayData[selectedRows.data[0].dataIndex].data[1]
        : null;
      const fridgeType = cabinetsList.find((e) => e._id === snSelected)
        ? cabinetsList.find((e) => e._id === snSelected).type
        : null;
      return (
        <CustomToolbarSelect
          fridgeType={fridgeType}
          setStatusUpdated={setStatusUpdated}
          selectedRows={selectedRows}
          displayData={displayData}
          setSelectedRows={setSelectedRows}
          setItems={setItems}
          items={items}
          cabinetsList={cabinetsList}
          setUpdateData={setUpdateData}
        />
      );
    },

    // onDownload: (buildHead, buildBody, columns, data) => {
    //   const cabinetDetailsIndex = columns.findIndex((col) => col.name === "cabinetDetails");
    //   const initiation_addressIndex = columns.findIndex((col) => col.name === "initiation_address");
    //   const execution_addressIndex = columns.findIndex((col) => col.name === "execution_address");
    //   const supplier_idIndex = columns.findIndex((col) => col.name === "supplier_id");
    //   const snIndex = columns.findIndex((col) => col.name === "sn");

    //   const transformedData = data.map((row, index) => {
    //     const rowData = [...row.data];

    //     if (cabinetDetailsIndex !== -1) {
    //       const cabinetDetails = data[row.dataIndex]?.cabinetDetails;
    //       rowData[cabinetDetailsIndex] = cabinetDetails?.type?.code;
    //     }

    //     if (initiation_addressIndex !== -1) {
    //       const initiation_address = data[row.dataIndex]?.initiation_address;

    //       let cityValue = "-";
    //       let neighbourhoodValue = "-";
    //       if (
    //         initiation_address &&
    //         initiation_address.city_id &&
    //         citiesList.filter((e) => e._id == initiation_address.city_id)[0]
    //       ) {
    //         cityValue = citiesList.filter((e) => e._id == initiation_address.city_id)[0].name;
    //       }
    //       if (
    //         initiation_address &&
    //         initiation_address.neighbourhood_id &&
    //         neighbourhoodsList.filter((e) => e._id == initiation_address.neighbourhood_id)[0]
    //       ) {
    //         neighbourhoodValue = neighbourhoodsList.filter(
    //           (e) => e._id == initiation_address.neighbourhood_id
    //         )[0]?.name;
    //       }

    //       rowData[initiation_addressIndex] =
    //         cityValue + ", " + neighbourhoodValue + ", ".initiation_address?.shop_name;
    //     }

    //     if (execution_addressIndex !== -1) {
    //       const execution_address = data[row.dataIndex]?.execution_address;

    //       let cityValue = "-";
    //       let neighbourhoodValue = "-";
    //       if (
    //         execution_address &&
    //         execution_address.city_id &&
    //         citiesList.filter((e) => e._id == execution_address.city_id)[0]
    //       ) {
    //         cityValue = citiesList.filter((e) => e._id == execution_address.city_id)[0].name;
    //       }
    //       if (
    //         execution_address &&
    //         execution_address.neighbourhood_id &&
    //         neighbourhoodsList.filter((e) => e._id == execution_address.neighbourhood_id)[0]
    //       ) {
    //         neighbourhoodValue = neighbourhoodsList.filter(
    //           (e) => e._id == execution_address.neighbourhood_id
    //         )[0]?.name;
    //       }

    //       rowData[execution_addressIndex] =
    //         cityValue + ", " + neighbourhoodValue + ", ".execution_address?.shop_name;
    //     }

    //     if (supplier_idIndex !== -1) {
    //       const supplier_id = data[row.dataIndex]?.supplier_id;
    //       let supplierValue = suppliersList.filter((e) => e._id == supplier_id);
    //       rowData[supplier_idIndex] = supplierValue.length ? supplierValue[0]?.name : "-";
    //     }
    //     if (snIndex !== -1) {
    //       const sn = data[row.dataIndex]?.sn;
    //       let snValue = cabinetsList.filter((e) => e._id == sn);
    //       rowData[snIndex] = snValue;
    //     }
    //     console.log("data", {
    //       ...row,
    //       data: rowData,
    //     });
    //     return {
    //       ...row,
    //       data: rowData,
    //     };
    //   });

    //   return buildHead(columns) + buildBody(transformedData);
    // },

    // onDownload: (buildHead, buildBody, columns, data) => {
    //   let tableOptions = [
    //     {name: "job_number", label: "Job Number", download: true},
    //     {name: "operation_number", label: "Operation #", download: true},
    //     {name: "operation_type", label: "Type", download: true},
    //     {name: "brand", label: "Brand", download: true},
    //     {name: "city", label: "City", download: true},
    //     {name: "neighbourhood", label: "Neighbourhood", download: true},
    //     {name: "shop_name", label: "Shop", download: true},
    //     {name: "mobile", label: "mobile", download: true},
    //     {name: "status", label: "Status", download: true},
    //     {name: "logistic_status", label: "Logistic", download: true},
    //     {name: "allocation_rule", label: "Allocation Rule", download: true},
    //     {name: "price_rule", label: "Price Rule", download: true},
    //     {name: "last_status_user", label: "Last Status User", download: true},
    //     {name: "last_status_update", label: "Last Status Update", download: true},
    //     {name: "supplier", label: "Supplier", download: true},
    //     {name: "sn", label: "SN", download: true},
    //     {name: "fridge_type", label: "Fridge Type", download: true},
    //     {name: "client", label: "Client", download: true},
    //     {name: "createdAt", label: "Creation Date", download: true},
    //     {name: "promise_date", label: "Promise Date", download: true},
    //     {name: "attempts", label: "Attempts", download: true},
    //   ];
    //   // let tableData = liveOperationsToExport.data.map((e, i) => ({index: i, data: Object.values(e)}));
    //   // return buildHead(tableOptions) + buildBody(tableData);
    //   // let tableOptions = [
    //   //   {name: "job_number", download: true},
    //   //   {name: "operation_number", download: true},
    //   //   {name: "operation_type", download: true},
    //   //   {name: "brand", download: true},
    //   //   {name: "city", download: true},
    //   //   {name: "neighbourhood", download: true},
    //   //   {name: "shop_name", download: true},
    //   //   {name: "mobile", download: true},
    //   //   {name: "status", download: true},
    //   //   {name: "allocation_rule", download: true},
    //   //   {name: "price_rule", download: true},
    //   //   {name: "last_status_user", download: true},
    //   //   {name: "last_status_update", download: true},
    //   //   {name: "supplier", download: true},
    //   //   {name: "sn", download: true},
    //   //   {name: "client", download: true},
    //   // ];
    //   const fields = tableOptions.map((opt) => opt.name);

    //   const tableData = liveOperationsToExport.data.map((item, index) => ({
    //     index,
    //     data: fields.map((field) => item[field] ?? ""), // maintain field order
    //   }));
    //   console.log(tableOptions, tableData[0].data);
    //   return buildHead(tableOptions) + buildBody(tableData);
    // },
    // serverSide: true,
    // count: pagingInfo.count, // Use total number of items
    count:
      tabIndex == 0
        ? pagingInfo.count
        : countLiveOperations && countLiveOperations.data
        ? countLiveOperations.data[tabsTitle[tabIndex - 1]] || 0
        : 0,
    page: pagingInfo.page,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        setPagingInfo({...pagingInfo, page: tableState.page, skip: tableState.page * pagingInfo.limit});
      } else if (action === "changeRowsPerPage") {
        setPagingInfo({...pagingInfo, limit: tableState.rowsPerPage});
      }
    },
  };
  const handleOpenOperationDialog = (id, supplierName) => {
    setOpenOperationDialog(true);
    setOperationId(id);
    setSupplierName(supplierName);
  };
  const handleOpenJobDialog = (id, supplierName) => {
    setOpenJobDialog(true);
    setJobNumber(id);
    setSupplierName(supplierName);
  };
  const handleOpenSnDialog = (id) => {
    setOpenSnDialog(true);
    setSnId(id);
  };
  const handleOpenAddDialog = () => {
    let path = `/admin/LiveOperationAdd`;
    history.push(path);
  };
  const handleFilter = () => {
    setFilterDialog(true);
  };

  //Search component ---------------START--------------
  const handleChangeSearch = (e, newValue) => {
    console.log(newValue);

    let values = [];

    newValue.forEach((v) => {
      let v_split = v.split(" ");
      v_split.forEach((vv) => {
        if (vv && vv != " ") values.push(vv);
      });
    });
    console.log(values);
    setSearchEntry(values);
  };
  //Search component ---------------END--------------

  return (
    <div>
      {countLiveOperations.total && !isLoading ? (
        <TabsOnTop
          items={items}
          setItemsFiltered={setItemsFiltered}
          tabIndex={tabIndex}
          setTabIndex={setTabIndex}
          countLiveOperations={countLiveOperations}
        />
      ) : null}
      <Container maxWidth="xl" style={{paddingTop: "4rem"}}>
        <Autocomplete
          multiple
          freeSolo
          limitTags={3}
          id="tags-standard"
          options={[]}
          getOptionLabel={(option) => option}
          value={searchEntry}
          onChange={handleChangeSearch}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              placeholder="Search Data"
              label="Filter by Job #, Operation # and Serial #"
            />
          )}
        />
        {!isLoading ? (
          <MuiThemeProvider theme={datatableThemeInTabsPage}>
            <MUIDataTable
              title=""
              data={itemsFiltered ? itemsFiltered : items}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        ) : (
          <CircularProgress size={30} className="pageLoader" />
        )}
      </Container>
      <div>
        {/*********************** -Operation Dialog START- ****************************/}
        <Dialog
          maxWidth={"xl"}
          fullWidth
          TransitionComponent={Transition}
          open={openOperationDialog}
          onClose={() => setOpenOperationDialog(false)}
        >
          <OperationDialog
            setOpenDialog={setOpenOperationDialog}
            operationId={operationId}
            supplierName={supplierName}
            cabinetsList={cabinetsList}
          />
        </Dialog>
        {/*********************** -Job Dialog START- ****************************/}
        <Dialog
          maxWidth={"xl"}
          fullWidth
          TransitionComponent={Transition}
          open={openJobDialog}
          onClose={() => setOpenJobDialog(false)}
        >
          <JobDialog
            setOpenDialog={setOpenJobDialog}
            jobNumber={jobNumber}
            supplierName={supplierName}
            cabinetsList={cabinetsList}
          />
        </Dialog>
        {/*********************** -Sn Dialog START- ****************************/}
        <Dialog
          maxWidth={"xl"}
          fullWidth
          TransitionComponent={Transition}
          open={openSnDialog}
          onClose={() => setOpenSnDialog(false)}
        >
          <SnDialog setOpenDialog={setOpenSnDialog} snId={snId} cabinetsList={cabinetsList} />
        </Dialog>
        {/*********************** FILTER start ****************************/}
        <Dialog
          onClose={() => setFilterDialog(false)}
          maxWidth={"xl"}
          fullWidth
          TransitionComponent={Transition}
          aria-labelledby="customized-dialog-title"
          open={filterDialog}
        >
          <FilterComponent
            warehousesList={warehousesList}
            storesList={storesList}
            filterFormValues={filterFormValues}
            setFilterFormValues={setFilterFormValues}
            setOpenDialog={setFilterDialog}
            setItems={setItems}
            setPagingInfo={setPagingInfo}
            pagingInfo={pagingInfo}
            setCountLiveOperations={setCountLiveOperations}
            setIsLoading={setIsLoading}
            setTabIndex={setTabIndex}
            setItemsFiltered={setItemsFiltered}
          />
        </Dialog>
      </div>

      <UploadExcel visible={importModalVisible} onClose={closeImport} />
    </div>
  );
}
